import { KdsInfoIcon, KdsLink, KdsText } from "@kazaar-platform/design-system";
import {
  RiCheckboxCircleFill,
  RiCloseCircleFill,
  RiLinksLine,
} from "@remixicon/react";
import { useTranslate } from "@tolgee/react";

import { OrderLogReadDtoActionTypeEnum } from "@/config/apiClient";

import { type OrderItemPageActivityLogCancellableStepProps } from "./OrderItemPageActivityLogCancellableStep.types";

export const OrderItemPageActivityLogCancellableStep = ({
  associatedOrderItemsLength,
  refusalReason,
  orderItemLog,
  file,
  customMessage,
  introText,
  suffixText,
  infoIconLabel,
}: OrderItemPageActivityLogCancellableStepProps) => {
  const { t } = useTranslate();

  return (
    <div className="prose-body-sm flex items-center gap-sp-xs2 text-text-body">
      {customMessage ?? (
        <div className="flex items-center gap-sp-xs2">
          <KdsText>{introText}</KdsText>

          {file && (
            <KdsLink href={file.url} target="_blank" size="sm">
              {file.name}
            </KdsLink>
          )}

          {(associatedOrderItemsLength ?? 0) > 1 && (
            <div className="flex items-center gap-sp-xs2">
              <RiLinksLine className="size-si-xs2" />
              <KdsText size="subtitle-sm" color="text-bodyvariant">
                {t(
                  "order.myOrdersItemDetails.activityFeed.action.quotes.multipleSuffix",
                  {
                    count: (associatedOrderItemsLength ?? 0) - 1,
                  }
                )}
              </KdsText>
            </div>
          )}

          <KdsText>{suffixText}</KdsText>

          {orderItemLog.actionType ===
            OrderLogReadDtoActionTypeEnum.QuoteValidated ||
          orderItemLog.actionType ===
            OrderLogReadDtoActionTypeEnum.ConfirmProof ||
          (orderItemLog.actionType ===
            OrderLogReadDtoActionTypeEnum.QuoteRefused &&
            refusalReason) ||
          (orderItemLog.actionType ===
            OrderLogReadDtoActionTypeEnum.RefusedProof &&
            refusalReason) ? (
            <KdsInfoIcon
              icon={refusalReason ? RiCloseCircleFill : RiCheckboxCircleFill}
              state={refusalReason ? "error" : "success"}
              label={infoIconLabel}
            />
          ) : (
            !customMessage && <KdsText>{infoIconLabel}</KdsText>
          )}
        </div>
      )}
    </div>
  );
};
